module.exports = "/assets/1b5d6a89c8ac1da52b120de34a4e18af.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SN.png
// module id = 2948
// module chunks = 0